
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"37","fill":"none","viewBox":"0 0 60 37"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M57.3 37H2.5C1.1 37 0 35.9 0 34.6V2.4C0 1.1 1.1 0 2.5 0h54.7c1.4 0 2.5 1 2.6 2.4v32.2c0 1.3-1.1 2.4-2.5 2.4zM2.5 1C1.7 1 1 1.7 1 2.4v32.2c0 .8.6 1.4 1.5 1.4h54.8c.8 0 1.5-.7 1.5-1.4V2.4c-.1-.8-.7-1.4-1.6-1.4H2.5z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M38.6 19.9h-2.1v-1.2h1.7V18h-1.7v-1h2v-.7h-2.8v4.4h2.9v-.8zm2.3.9c.4 0 .8-.1 1.1-.1l-.1-.7c-.3.1-.6.2-.9.2-.9 0-1.2-.4-1.2-1.6 0-1.1.4-1.5 1.2-1.5.4 0 .7 0 .9.1l.1-.7c-.2-.1-.6-.2-1-.2-1.4 0-2 .7-2 2.2 0 1.6.6 2.3 1.9 2.3zm-11.3 0c.4 0 .8-.1 1.1-.1l-.1-.7c-.3.1-.6.2-.9.2-.9 0-1.2-.4-1.2-1.6 0-1.1.4-1.5 1.2-1.5.4 0 .7 0 .9.1l.1-.7c-.2-.1-.6-.2-1-.2-1.4 0-2 .7-2 2.2 0 1.6.6 2.3 1.9 2.3zm2.5-2h1.8v1.9h.8v-4.4h-.8v1.8h-1.8v-1.8h-.8v4.4h.8v-1.9zm11.5 0h.5l1.2 1.9h1l-1.5-2.3 1.4-2.1h-.9l-1.2 1.8h-.6v-1.8h-.8v4.4h.9v-1.9zM54 15.5h-5.9v6H54v-6zm-1 3.6h-1.4v1.4h-1.1v-1.4H49V18h1.5v-1.4h1.1V18H53v1.1zm-42.3 1.7c1.1 0 1.7-.5 1.7-1.6v-2.8h-.8v2.8c0 .6-.3.9-.9.9-.6 0-.9-.3-.9-.9v-2.8H9v2.8c0 1.1.6 1.6 1.7 1.6zm3.5-2.6v-.5l.2.4 1.8 2.6h.6v-4.5h-.7v3l-.2-.4-1.7-2.5h-.7v4.4h.7v-2.5zm-5.7 1.7H6.6v-3.6h-.8v4.4h2.7v-.8zM27 18.4h-1.6v.6H27v-.6zm-5 .4h1.8v1.9h.8v-4.4h-.8v1.8H22v-1.8h-.8v4.4h.8v-1.9zm-2.5 2c.3 0 .7-.1 1.1-.1l-.1-.7c-.3.1-.6.2-.9.2-.9 0-1.2-.4-1.2-1.6 0-1.1.4-1.5 1.2-1.5.4 0 .7 0 .9.1l.1-.7c-.2-.1-.6-.2-1-.2-1.4 0-2 .7-2 2.2 0 1.6.6 2.3 1.9 2.3z"}})])
          )
        }
      }
    